export { isIE11, isEdge, isFirefox, isSafari } from './BrowserTest';